<div class="top-navbar">
  <!-- Left Section: Logo and Page Name -->
  <div class="left-section">
    <img src="home/top-navbar/topbar-logo.png" alt="Logo" class="logo">
    <span class="page-name">Mapsy</span>
  </div>

  <div class="title">
    <span>Switch languages at runtime: </span>
    <button (click)="useLanguage('en')">en</button>
    <button (click)="useLanguage('hr')">hr</button>
</div>

  <!-- Right Section: User Info and Logout -->
  <div class="right-section">
    <ng-container *ngIf="user$ | async as currentUser; else guest">
      <span class="user-name">{{ currentUser?.user?.username || currentUser?.user?.email || 'User' }}</span>
      <span class="user-roles">{{ (currentUser?.user?.roles || currentUser?.roles || []).join(', ') }}</span>
      <img src="home/top-navbar/avatar.jpg" alt="User Avatar" class="user-avatar">
      <button class="logout-button" (click)="authService.logout(); router.navigate(['/login'])">
        <img src="home/top-navbar/log-out.png" alt="logout button" width="30px" height="30px">
      </button>
    </ng-container>
    <ng-template #guest>
      <a routerLink="/login">Prijava</a>
    </ng-template>
    
  </div>
</div>

